$.extend($.ui.multiselect, {
    locale: {
        addAll:'Přidat vše',
        removeAll:'Odebrat vše',
        itemsCount:'položek vybráno'
    }
});
